export default __webpack_public_path__ + "static/media/com-foto4.7394a819.jpg";